import { render, staticRenderFns } from "./PartnerJoin.vue?vue&type=template&id=2f8e4214&"
import script from "./PartnerJoin.vue?vue&type=script&lang=js&"
export * from "./PartnerJoin.vue?vue&type=script&lang=js&"
import style0 from "./PartnerJoin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports